import update from "immutability-helper";
import { AuthReduxActions } from "./Action";

export interface AuthState {
  accessToken: string;
  refreshToken: any;
  isUserLoggedIn: boolean;
  //-------
  rowLoanStatus: any[];
  selectedLoan: string;
  hasMultipleLoans: boolean;
  brokerDetails: any;
  userRole: any;
}

const authState: AuthState = {
  accessToken: "",
  refreshToken: "",
  isUserLoggedIn: false,
  //-------
  rowLoanStatus: [],
  selectedLoan: "",
  hasMultipleLoans: false,
  brokerDetails: null,
  userRole: null,
};

const AuthStateReducer = (
  state: AuthState = authState,
  action: any = { type: "", payload: {} }
): AuthState => {
  switch (action.type) {
    case AuthReduxActions.SET_AUTH_DATA:
      return update(state, {
        $merge: {
          ...action.payload,
        },
      });
    case AuthReduxActions.LOGOUT:
      return update(state, {
        $merge: {
          ...authState,
        },
      });
    default:
      return state;
  }
};

export default AuthStateReducer;
